import { mergeData } from 'vue-functional-data-merge'
import Spinner from '~/components/ui/spinner'

export default {
  name: 'Loader',
  functional: true,
  components: {
    Spinner,
  },
  props: {
    centered: {
      default: false,
      type: Boolean,
    },
    loader: {
      default: null,
      type: [String, Array],
    },
    loading: {
      default: true,
      type: Boolean,
    },
    noPlaceholder: {
      default: false,
      type: Boolean,
    },
    noSpinner: {
      default: false,
      type: Boolean,
    },
    placeholder: {
      default: 'Loading&hellip;',
      type: String,
    },
    spinnerInverted: {
      default: false,
      type: Boolean,
    },
    spinnerMono: {
      default: false,
      type: Boolean,
    },
    spinnerSize: {
      default: 'lg',
      type: String,
    },
    tag: {
      default: 'div',
      type: String,
    },
  },
  render (h, { data, props, slots }) {
    const resolvedSlots = slots()

    const wrapperData = {
      class: {
        'loader--loading': props.loading,
        'loader--loaded': !props.loading,
        'loader--centered': props.centered,
      },
      staticClass: 'loader',
    }

    /**
     * Render a spinner element and placeholder text.
     * @return {*}
     */
    function renderSpinner () {
      const spinner = h(Spinner, {
        props: {
          inverted: props.spinnerInverted,
          mono: props.spinnerMono,
          size: props.spinnerSize,
        },
        staticClass: 'loader__spinner',
      })

      const placeholder = h('p', {
        domProps: {
          innerHTML: props.placeholder,
        },
        staticClass: 'loader__placeholder text-center',
        style: {
          marginBottom: 0,
        },
      })

      return h('div', [
        props.noSpinner ? h(false) : resolvedSlots.spinner || spinner,
        props.noPlaceholder ? h(false) : resolvedSlots.placeholder || placeholder,
      ])
    }

    return h(props.tag, mergeData(wrapperData, data), [
      props.loading ? renderSpinner() : resolvedSlots.default || h(false),
    ])
  },
}
